// src/components/QrScanner.js
import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { toast } from 'react-toastify';

const qrcodeRegionId = "html5qr-code-full-region";

const QrScanner = ({ onScanSuccess, onScanError }) => {
    const html5QrcodeRef = useRef(null);

    useEffect(() => {
        // Cria uma instância do scanner
        if (!html5QrcodeRef.current) {
            html5QrcodeRef.current = new Html5Qrcode(qrcodeRegionId);
        }
        const html5QrcodeScanner = html5QrcodeRef.current;

        const config = {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            // Não definimos facingMode aqui, vamos tentar pelo ID
        };

        const startScanner = async () => {
            try {
                const devices = await Html5Qrcode.getCameras();
                let cameraId = null;

                if (devices && devices.length) {
                    // Tenta encontrar a câmera traseira (environment)
                    const rearCamera = devices.find(device => 
                        device.label.toLowerCase().includes('back') || 
                        device.label.toLowerCase().includes('rear') ||
                        device.label.toLowerCase().includes('ambiente')
                    );

                    if (rearCamera) {
                        cameraId = rearCamera.id;
                    } else {
                        // Se não encontrar pelo nome, usa a primeira câmera (índice 0)
                        cameraId = devices[0].id;
                    }
                }

                if (!cameraId) {
                    onScanError("Nenhuma câmera encontrada no dispositivo.");
                    return;
                }

                // Inicia o scanner usando o ID da câmera
                await html5QrcodeScanner.start(
                    cameraId,
                    config,
                    (decodedText, decodedResult) => {
                        // Sucesso na leitura
                        html5QrcodeScanner.stop().catch(err => console.error("Erro ao parar scanner:", err));
                        onScanSuccess(decodedText);
                    },
                    (errorMessage) => {
                        // Erro de decodificação (ocorre a cada frame sem QR code) - ignorado
                    }
                );
            } catch (err) {
                // Erro de inicialização (e.g., permissão negada, câmera não encontrada)
                console.error("Erro ao iniciar scanner:", err);
                const errorMessage = err.message || "Não foi possível iniciar a câmera. Verifique as permissões.";
                onScanError(errorMessage);
                
                // Se o erro for de permissão, o toast já foi exibido na página pai.
                // Se for um erro de câmera não encontrada, tentamos um fallback mais simples (apenas facingMode)
                if (err.message.includes('NotAllowedError') || err.message.includes('NotFoundError')) {
                    // Não fazemos nada, o erro já foi reportado
                } else {
                    // Tentativa de fallback usando facingMode (menos fiável, mas pode funcionar)
                    try {
                        await html5QrcodeScanner.start(
                            { facingMode: "environment" },
                            config,
                            onScanSuccess,
                            () => {} // Ignorar erros de decodificação
                        );
                    } catch (fallbackErr) {
                        onScanError(fallbackErr.message || "Falha ao iniciar a câmera após tentativa de fallback.");
                    }
                }
            }
        };

        startScanner();

        // Cleanup function: para o scanner quando o componente é desmontado
        return () => {
            if (html5QrcodeScanner.isScanning) {
                html5QrcodeScanner.stop().catch(err => console.error("Erro ao parar scanner no cleanup:", err));
            }
        };
    }, [onScanSuccess, onScanError]);

    return (
        <div className="qr-scanner-wrapper flex flex-col items-center text-center">
            {/* O div onde o html5-qrcode irá renderizar o vídeo */}
            <div id={qrcodeRegionId} className="w-full max-w-md mx-auto rounded-lg overflow-hidden shadow-lg relative" style={{ height: '300px' }}>
                {/* O conteúdo do vídeo será injetado aqui */}
            </div>
            <p className="scanner-message mt-2 text-center text-sm text-muted-foreground">
                Aponte a câmera para o QR Code.
            </p>
        </div>
    );
};

export default QrScanner;